<template>
  <div class="modal" v-if="seen">
    <div class="deletefile">
      <span @click="close" class="closefile">
        <img src="@/assets/Close Button.svg" />
      </span>
      <div class="d-flex justify-content-center align-items-center mt-4">
        <img src="@/assets/trash-can.svg" />
      </div>
      <div class="header d-flex justify-content-center align-items-center mt-2">
        <h6><strong>Delete user?</strong></h6>
      </div>
      <div class="cgn text-center mb-2">
        <span>Are you sure you want to delete &nbsp;(<strong>{{ name }}</strong>)</span>
      </div>
      <div class="save">
        <span class="btn-delete-permanently" @click="close">
          Cancel
        </span>
        <span class="btn-move-to-trash" @click="delete_user">
          Delete permanently
        </span>
      </div>
    </div>
  </div>
</template>
<style scoped>
.header {
  padding: .5em 0 0 0 !important;
}

.header h3 {
  font-size: 22px;
  font-weight: bold;
}

.save {
  margin-top: 0 !important;
}

.cgn {
  display: flex;
  flex-direction: column;
}

.cgn span {
  margin-bottom: .4em;
  font-size: 14px;
}

.deletefile {
  padding: 2em !important;
}

.modal div.deletefile {
  width: 420px !important;
}

.modal div.deletefile div {
  width: 100% !important;
  margin-left: 0 !important;
}

.save {
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
}

.save span {
  flex: 1 !important;
}

.save .btn-move-to-trash {
  background: #3F96D1 !important;
  color: #fff !important;
  font-size: 13px !important;
}

.save .btn-delete-permanently {
  background: transparent !important;
  border: 1px solid #FC6D6C !important;
  font-size: 13px !important;
  color: #FC6D6C !important;
}

.save .btn-delete {
  background: transparent !important;
  border: 1px solid #FC6D6C !important;
  font-size: 13px !important;
  color: #FC6D6C !important;
}

.modal div.deletefile .closefile {
  top: 13px !important;
  right: 13px !important;
}
</style>
<script>
import cookies from '@/services/cookies'
export default {
  data() {
    return {
      seen: false,
      id: '',
      name: '',
      index: ''
    }
  },
  methods: {
    remove_user(index) {
      this.$parent.remove_user(index)
    },
    notify(msg) {
      this.$parent.notify(msg)
    },
    closearchiveuserloader() {
      this.$parent.closearchiveuserloader()
    },
    warninglog(files, name, index, id) {
      this.$parent.warninglog(files, name, index, id)
    },
    logincall() {
      this.$parent.logincall()
    },
    loading() {
      this.$parent.loading()
    },
    closeloader() {
      this.$parent.closeloader()
    },
    load(id, name, index) {
      this.index = index
      this.id = id
      this.name = name
      this.seen = true
    },
    delete_user() {
      let data = {
        token: cookies.getCookie('token'),
        id: this.id
      }

      this.loading()

      let that = this

      this.$socket.emit('delete-user-permanently', data, function (data) {
        if (data.data === true) {
          that.closeloader()
          that.seen = false
          that.remove_user(that.index)
          that.notify(that.name + ' deleted successfully...')
        }

        if (data.data === false) {
          that.closeloader()
          that.seen = false
          that.logincall()
          that.$router.push('/login')
        }
      })
    },
    close() {
      this.seen = false
    }
  }
}
</script>
